import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import BAITable from "./BAITable";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة مؤشر سمنة الجسم";
const DESCRIPTION = " استخدم هذه الحاسبة لتحديد مؤشر كتلة الدهون في جسمك (BAI) بشكل دقيق ";
const KEYWORDS = "BAI، حاسبة مؤشر السمنة، سمنة، مؤشر السمنة";
const OG_URL = "https://do-calculate.com/calculator/ar/bai-calculator/";
function BAIcalculator() {
  const [height, setHeight] = useState();
  const [hipCircumference, setHipCircumference] = useState();
  const [gender, setGender] = useState("male");
  const [age, setAge] = useState();
  const [result, setResult] = useState();
  const [classification, setClassification] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      setError("");
      setResult("");
      if (age < 20) {
        setError("مؤشر سمنة الجسم مخصص للأعمار فوق 20 سنة");
        return;
      }
      const heightInMeters = height / 100;
      const BAI = hipCircumference / Math.pow(heightInMeters, 1.5) - 18;
      setResult(BAI.toFixed(2));
      if (gender === "female") {
        if (age >= 20 && age <= 39) {
          if (BAI < 21) setClassification("Underweight");
          else if (BAI >= 21 && BAI <= 33) setClassification("Healthy");
          else if (BAI > 33 && BAI <= 39) setClassification("Overweight");
          else if (BAI > 39) setClassification("Obese");
        } else if (age >= 40 && age <= 59) {
          if (BAI < 23) setClassification("Underweight");
          else if (BAI >= 23 && BAI <= 35) setClassification("Healthy");
          else if (BAI > 35 && BAI <= 41) setClassification("Overweight");
          else if (BAI > 41) setClassification("Obese");
        } else if (age >= 60 && age <= 79) {
          if (BAI < 25) setClassification("Underweight");
          else if (BAI >= 25 && BAI <= 38) setClassification("Healthy");
          else if (BAI > 38 && BAI <= 43) setClassification("Overweight");
          else if (BAI > 43) setClassification("Obese");
        }
      } else if (gender === "male") {
        if (age >= 20 && age <= 39) {
          if (BAI < 8) setClassification("Underweight");
          else if (BAI >= 8 && BAI <= 21) setClassification("Healthy");
          else if (BAI > 21 && BAI <= 26) setClassification("Overweight");
          else if (BAI > 26) setClassification("Obese");
        } else if (age >= 40 && age <= 59) {
          if (BAI < 11) setClassification("Underweight");
          else if (BAI >= 11 && BAI <= 23) setClassification("Healthy");
          else if (BAI > 23 && BAI <= 29) setClassification("Overweight");
          else if (BAI > 29) setClassification("Obese");
        } else if (age >= 60 && age <= 79) {
          if (BAI < 13) setClassification("Underweight");
          else if (BAI >= 13 && BAI <= 25) setClassification("Healthy");
          else if (BAI > 25 && BAI <= 31) setClassification("Overweight");
          else if (BAI > 31) setClassification("Obese");
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حسب مؤشر كتلة الدهون في الجسم (BAI) بدقة وسهولة! باستخدام
                  حاسبتنا المتقدمة، يمكنك تحديد مؤشر كتلة الدهون في جسمك (BAI)
                  بشكل دقيق في ثوانٍ معدودة. ما عليك سوى إدخال قياسات بسيطة مثل
                  محيط الورك والطول، وستحصل على نتيجة فورية ومفصلة. تم تطوير هذه
                  الحاسبة بناءً على أحدث الأبحاث العلمية في مجال قياس الدهون في
                  الجسم، مما يضمن لك دقة واعتمادية النتائج.
                </p>
                <p>
                  لماذا مؤشر BAI مهم؟ مؤشر كتلة الدهون في الجسم (BAI) هو مقياس
                  أكثر دقة لتقدير نسبة الدهون في الجسم مقارنة بمؤشر كتلة الجسم
                  التقليدي (BMI)، خاصةً للأشخاص الذين يعانون من السمنة أو يعانون
                  من نقص الوزن. يساعدك معرفة مؤشر BAI الخاص بك على تتبع تقدمك
                  نحو تحقيق وزن صحي والحفاظ عليه، واتخاذ قرارات مستنيرة بشأن
                  نظامك الغذائي وممارسة الرياضة.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-groupitems-center">
                      <label className="form-label ms-2" htmlFor="age">
                        ادخل العمر
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="أدخل العمر"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="gender">
                        اختر الجنس
                      </label>
                      <select
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">ذكر</option>
                        <option value="female">أنثى</option>
                      </select>
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="height">
                        ادخل الطول
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="height"
                          type="number"
                          value={height}
                          onChange={(e) => setHeight(e.target.value)}
                          placeholder="أدخل الطول"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text ">سم</span>
                      </div>
                    </div>
                    <div className="form-group items-center">
                      <label
                        className="form-label ms-2"
                        htmlFor="hipCircumference"
                      >
                        ادخل محيط الورك
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="hipCircumference"
                          type="number"
                          value={hipCircumference}
                          onChange={(e) => setHipCircumference(e.target.value)}
                          placeholder="أدخل محيط الورك"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text ">سم</span>
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">{result}</p>
                      <p className="text-white">
                        {classification === "Underweight"
                          ? "نقص وزن"
                          : classification === "Healthy"
                          ? "وزن صحي"
                          : classification === "Overweight"
                          ? "زيادة وزن"
                          : classification === "Obese"
                          ? "سمنة"
                          : ""}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {gender === "female" && (
                  <BAITable classification={classification} gender="female" />
                )}
                {gender === "male" && (
                  <BAITable classification={classification} gender="male" />
                )}
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية استخدام الحاسبة</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>خطوات الاستخدام</h2>
                  </u>
                  <p>1. أدخل العمر والجنس.</p>
                  <p>2. أدخل الطول ومحيط الورك.</p>
                  <p>3. انقر على زر "احسب".</p>
                  <div className="p-3 mb-2 bg-info ">
                    مثال: إذا كان طولك 170 سم ومحيط وركك 100 سم، فإن BAI الخاص
                    بك هو X.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>معلومات إضافية</h2>
                  </u>
                  <p>
                    مؤشر سمنة الجسم (BAI) يستخدم لتقدير نسبة الدهون في الجسم.
                  </p>
                  <p>
                    يختلف عن مؤشر كتلة الجسم (BMI) في أنه يأخذ في الاعتبار توزيع
                    الدهون في الجسم.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BAIcalculator;
